module.exports = __webpack_public_path__ + "static/media/ระบบกลาง_[คู่มือการใช้งาน] สำหรับหน่วยงาน_213.1ad4834a.pdf";